export default __webpack_public_path__ + "static/MainSong-3013301cc7fe5ac01abd075fb0cf3239.mp3";